import { render } from "./TablePanel.vue?vue&type=template&id=fbc7506a&scoped=true"
import script from "./TablePanel.vue?vue&type=script&lang=js"
export * from "./TablePanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/submissionsPanel.scss?vue&type=style&index=0&id=fbc7506a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc7506a"]])

export default __exports__